module.exports = __webpack_public_path__ + "static/img/gl-8.c201d73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-8.jpg
// module id = tlXP
// module chunks = 0